(function () {

  function initMulticoresFAQ() {

    document.addEventListener('click', function (event) {

      var button = event.target.closest('.mc-faq-question');

      if (!button) return;

      var item = button.closest('.mc-faq-item');

      if (!item) return;

      var faq = button.closest('.mc-faq');

      if (!faq) return;

      faq.querySelectorAll('.mc-faq-item.active').forEach(function (otherItem) {

        if (otherItem !== item) {
          otherItem.classList.remove('active');

          var otherButton = otherItem.querySelector('.mc-faq-question');

          if (otherButton) {
            otherButton.setAttribute('aria-expanded', 'false');
          }
        }

      });

      var isActive = item.classList.toggle('active');

      button.setAttribute(
        'aria-expanded',
        isActive ? 'true' : 'false'
      );

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initMulticoresFAQ
    );

  } else {

    initMulticoresFAQ();

  }

})();